/* import __COLOCATED_TEMPLATE__ from './banner-flash.hbs'; */
/**
## Flash Banner

This component should not be used directly, but is used internally by the [flash
service](/glass/docs/development/flash.html) (see `services/flash.js` in Glass). It is used for interactive messaging
in response to merchant activity such as editing and saving. For static
messaging, please use [`banner-static`](/components/glass/banner-static.html).

```example
@hbs
{{banner-flash type="SUCCESS"
               isActive=true
               message="You win!"}}
{{banner-flash type="WARNING"
               isActive=true
               message="You warn!"}}
{{banner-flash type="ERROR"
               isActive=true
               message="You lose!"}}
```

### Parameters
@param {String} [type=null] The type of a flash message can be `ERROR`, `SUCCESS` or `WARNING`
@param {Boolean} [isActive=null] Set to `true` to show Flash message, `false` to hide.
@param {String} [message=null] Message shown in the flash message.
@param {Action} [dismiss=null] Optional dismiss action. If provided, a close icon will be rendered that simply calls this action on click, which is then responsible for updating whatever state is needed to dismiss the flash.

 */

import Component from '@ember/component';
import { computed } from '@ember/object';
import { FLASH_TYPES } from '@square/glass-ui/utils/flash-types';
import alertTriangleIconComponent from '@square/glass-ui/components/svg/icon-alert-triangle';
import checkmarkCircleIconComponent from '@square/glass-ui/components/svg/icon-checkmark-circle';
import infoCircleIconComponent from '@square/glass-ui/components/svg/icon-info-circle';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['banner-flash'],
  classNameBindings: ['isActive:banner-flash--is-visible', 'typeClass'],
  isActive: null,
  message: null,
  type: null,
  typeClass: computed('type', function () {
    switch (this.get('type')) {
      case FLASH_TYPES.ERROR:
        return 'banner-flash--is-error';
      case FLASH_TYPES.SUCCESS:
        return 'banner-flash--is-successful';
      case FLASH_TYPES.WARNING:
        return 'banner-flash--is-warning';
      default:
        return '';
    }
  }),
  iconComponent: computed('type', function () {
    switch (this.get('type')) {
      case FLASH_TYPES.ERROR:
        return alertTriangleIconComponent;
      case FLASH_TYPES.SUCCESS:
        return checkmarkCircleIconComponent;
      case FLASH_TYPES.WARNING:
        return alertTriangleIconComponent;
      default:
        return infoCircleIconComponent;
    }
  }),
  iconColor: computed('type', function () {
    switch (this.get('type')) {
      case FLASH_TYPES.ERROR:
        return 'white';
      case FLASH_TYPES.SUCCESS:
        return 'white';
      case FLASH_TYPES.WARNING:
        return 'base';
      default:
        return 'base';
    }
  })
});